import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-ai-config-job-history-skeleton',
  templateUrl: './ai-config-job-history-skeleton.component.html',
  styleUrls: ['./ai-config-job-history-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class AiConfigJobHistorySkeletonComponent {
  readonly tableRows = [1, 2, 3, 4, 5, 6];
  readonly tableCols = [1, 2, 3, 4, 5, 6, 7, 8, 9];
}